import { IndicationOrderableField, OrderType } from 'graphql/types'
import logger from 'lib/logger'

export type TIndication = 'Publicado' | 'Em Análise' | 'Desqualificado'

export const openSummaryEvent = () =>
  logger.action('partner-indications-summary-open')

export const clickSummaryCardEvent = (type: TIndication) =>
  logger.action('partner-indications-summary-card-click', {
    type,
  })

export const clickCreateIndicationEvent = () =>
  logger.action('partner-indications-summary-new-indication-cta')

export const clickFocusRegionsEvent = () =>
  logger.action('partner-indications-summary-focus-region-cta')

export const openFocusRegionsEvent = () =>
  logger.action('partner-focus-region-page')

export const openIndicationsEvent = (type: TIndication) =>
  logger.action('partner-indications-detail-open', {
    type,
  })

export const orderByIndicationsEvent = ({
  type,
  field,
}: {
  type: OrderType
  field: IndicationOrderableField
}) =>
  logger.action('partner-indications-detail-page-orderby', {
    type,
    field,
  })

export const paginationIndicationsEvent = ({ page }: { page: number }) =>
  logger.action('partner-indications-detail-page-pagination', {
    page,
  })

export const backButtonIndicationsEvent = () =>
  logger.action('partner-indications-detail-back-button')

export const clickFAQButtonEvent = () =>
  logger.action('partner-indications-faq-button')

export const openFAQEvent = () => logger.action('partner-indications-faq-open')

export const clickFAQItemEvent = (item: string) =>
  logger.action('partner-indications-faq-accordion', {
    item,
  })
